import React from 'react';
import { ArrowLeft } from 'lucide-react';

const AboutSection = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-white px-4 sm:px-0">
      
      {/* Desktop Header */}
      <div className="py-4">
        <h2 className="text-2xl font-semibold text-black">About Wryven</h2>
      </div>

      <p className="px-0 max-w-2xl font-semibold text-[#6b8f3a] text-sm pb-2 sm:mb-4">A home for writers and creators worldwide</p>

      {/* Content */}
      <div className="py-4 sm:py-0 max-w-2xl">
        {/* Logo and App Name Section */}
        <div className="mb-6 flex items-center gap-2">
          <img 
            src="/logos/Wryven-Feather-Color.png?v=1.0" 
            alt="Wryven Logo"
            className="w-24 h-24 sm:w-20 sm:h-20 rounded-2xl flex-shrink-0 object-cover"
            loading="lazy"
          />
          <h1 className="wryven-font text-6xl text-gray-900">Wryven</h1>
        </div>

        {/* Introduction */}
        <p className="text-black text-base mb-6">
          Wryven is a vibrant social platform built for writers, poets, storytellers, and songwriters. 
          Here, creativity knows no boundaries—anyone from anywhere can share their thoughts, emotions, and stories, 
          while discovering and admiring the talents of others. Whether you write poetry, shayaris, novels, songs, or scripts, Wryven gives your words a stage to shine.
        </p>

        {/* Why Choose Wryven */}
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold text-black mb-2">Why Choose Wryven?</h3>
            <p className="text-black text-base">
              Wryven is more than just a platform—it's a community where creativity thrives. 
              We prioritize authentic expression, genuine admiration, and meaningful connections. 
              Every writer, whether budding or experienced, finds a place to share, learn, and grow.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-black mb-2">Connect With Like-Minded Creators</h3>
            <p className="text-black text-base">
              Discover writers from around the world, admire their work, and engage in inspiring conversations. 
              Your creativity meets appreciation, and your words resonate beyond borders.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-black mb-2">Express Yourself Freely</h3>
            <p className="text-black text-base">
              From poems to novels, songs to scripts, Wryven empowers you to express your thoughts in your own unique style. 
              We celebrate every voice, and every story matters here.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-black mb-2">Grow and Inspire</h3>
            <p className="text-black text-base">
              Get inspired by the works of others, receive constructive admiration, and enhance your craft. 
              Wryven is a space where your creativity meets opportunity, and where writers uplift one another.
            </p>
          </div>
        </div>

        {/* Footer / Rights */}
        <div className="p-4 sm:p-6 mt-8">
          <p className="text-sm text-black text-center">
            © 2026 Wryven. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
